import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable max-len */ import { AudioVideoComponent, FlexNavigate, FlexVideo } from '@tencent/cms-design-component';
import React, { useCallback } from 'react';
import NoticeComponent from './components/NoticeComponent';
// import { useDomains } from './hooks/useDomains';
import Jp2component from './Jp2component';
import dataFormat from './utils/data-format';
export default function ConfigDetail(param) {
    var configData = param.configData, _lang = param.lang, lang = _lang === void 0 ? 'en' : _lang;
    var _components = configData.components, components = _components === void 0 ? [] : _components;
    // const domains = useDomains();
    var filterConfigData = components.filter(function(item) {
        return item.lang === lang;
    }); // 当前语种有数据，则正常展示
    if (filterConfigData.length === 0) {
        filterConfigData = components.filter(function(item) {
            return item.lang === 'en';
        });
    }
    // 判断当前语种有没有配置Notice组件，Notice组件需要特别展示
    var noticeData = filterConfigData.filter(function(item) {
        return item.component_id === 'Notice';
    });
    var Notice = function() {
        if (noticeData.length) {
            return NoticeComponent(noticeData[0]); // Notice组件比较特别，理论上一个页面只能有一个，所以这里固定取第一条数据
        }
        return '';
    };
    // 还是保留了对banner的逻辑，过渡线上切换
    var bannerData = filterConfigData.filter(function(item) {
        return item.component_id === 'Banner' || item.component_id === 'NewBanner';
    }); // 判断当前语种有没有配置banner组件，banner组件需要特别展示
    var Banner = function() {
        if (bannerData.length) {
            return(/*#__PURE__*/ _jsx(Jp2component, {
                data: bannerData[0]
            })); // Banner组件比较特别，理论上一个页面只能有一个，所以这里固定取第一条数据
        }
        return '';
    };
    var AnotherBanner = function() {
        if (bannerData.length > 1) {
            return(/*#__PURE__*/ _jsx(Jp2component, {
                data: bannerData[1]
            })); // 需求: Banner组件可以有第二个，放在页面最下面
        }
        return '';
    };
    if (bannerData.length) {
        filterConfigData = filterConfigData.filter(function(item) {
            return ![
                'Banner',
                'NewBanner',
                'Notice'
            ].includes(item.component_id.trim());
        }); // 如果有banner Contact组件，其他展示区域剔除banner Contact模块
    }
    var navData = [];
    if (filterConfigData.length) {
        filterConfigData.map(function(item) {
            var component_object = item.component_object;
            var properties = JSON.parse(component_object).properties; // 获取cms的具体配置信息
            // 埋入产品服务介绍数据
            // eslint-disable-next-line camelcase
            // if (component_id === 'ProductsService') {
            //   item.productsServiceData = productsServiceData;
            // }
            if (Object.values(properties)[0].title === '请输入模块名称') {
                var modTitle = Object.values(properties)[0].default;
                if (!modTitle) {
                    return;
                }
                var item1 = {
                    label: modTitle
                };
                navData.push(item1);
            }
        });
    }
    var onNavigatorTabClick = useCallback(function(item, index) {
        var label = item && item.label;
        // 返回的index是数字，从0开始。这里上报从1开始
        window.recordBehavior && window.recordBehavior.reportEvent('click_navigator_tab', {
            ext1: index + 1,
            ext2: label
        });
    }, []);
    // 一级页面不用显示导航，其他都显示
    var showFlexNavigate = ![
        'pricing'
    ].includes(configData.page_eid);
    // 判断是否含有组件组合的tab组件
    var audioVideoData = filterConfigData.filter(function(item) {
        return item.component_id === 'AudioVideoComponent';
    });
    var audioDataObj = {
    };
    if (audioVideoData.length) {
        // 过滤掉tab组件，只能存在一个tab导航
        filterConfigData = filterConfigData.filter(function(item) {
            return item.component_id !== 'AudioVideoComponent';
        });
        var ref = dataFormat.formatAudioVideoComponent(filterConfigData, audioVideoData[0], Jp2component), audioUsedComponent = ref.audioUsedComponent, audioData = ref.audioData;
        filterConfigData = audioUsedComponent;
        audioDataObj = audioData;
        showFlexNavigate = false; // 组件组合的tab和原来的tab导航互斥
    }
    var AudioVideoComponentJp = function() {
        if (audioVideoData.length) {
            return(/*#__PURE__*/ _jsx("div", {
                id: audioDataObj.modTitle || audioVideoData[0].component_id,
                children: /*#__PURE__*/ _jsx(AudioVideoComponent, {
                    title: audioDataObj.modTitle,
                    configuration: audioDataObj.configuration
                })
            }));
        }
        return '';
    };
    return(/*#__PURE__*/ _jsxs("div", {
        className: "portal-render__old-render",
        children: [
            /*#__PURE__*/ _jsx(Notice, {
            }),
            /*#__PURE__*/ _jsx(Banner, {
            }),
            showFlexNavigate && !!navData.length && /*#__PURE__*/ _jsx(FlexNavigate, {
                configuration: navData,
                onTabClick: onNavigatorTabClick
            }),
            /*#__PURE__*/ _jsx(AudioVideoComponentJp, {
            }),
            filterConfigData.map(function(item, index) {
                /*#__PURE__*/ return _jsx(Jp2component, {
                    data: item,
                    index: index
                }, index);
            }),
            /*#__PURE__*/ _jsx(FlexVideo, {
                postMessageUrl: '/solution-new/tcp-player'
            }),
            /*#__PURE__*/ _jsx(AnotherBanner, {
            })
        ]
    }));
};
